module.exports = __webpack_public_path__ + "img/remita-logo.86030efd.svg";